import {
	GovIcon,
	GovMessage,
	type GovMessageProps,
} from '@gov-design-system-ce/react';
import type { ReactNode } from 'react';

export interface LightbulbMessageProps {
	message?: string;
	children?: ReactNode;
	color?: GovMessageProps['color'];
	type?: GovMessageProps['type'];
}

export const LightbulbMessage = ({
	message,
	children,
	color = 'primary',
	type = 'subtle',
}: LightbulbMessageProps) => (
	<GovMessage
		color={color}
		type={type}
		icon={
			<GovIcon
				type="components"
				name="lightbulb-fill"
			/>
		}>
		{children ?? message}
	</GovMessage>
);
